import { InfoChips } from "@website/ui/info-chips";
import { ListItem } from "@website/ui/list-item";
import { isChannel } from "@website/utils/channel/helpers";
import { useRouter } from "next/router";
import { useNavbar } from "./navbar.hook";

export const Navbar = () => {
  const { list, profileType, isCollapsed, setIsCollapsed } = useNavbar();
  const router = useRouter();
  return (
    <div
      className={`${
        router.pathname === "/" ? "" : "max-lg:hidden"
      } lg:border-outline-thin mb-6 max-lg:w-full lg:sticky lg:h-fit lg:rounded-lg lg:border ${
        isCollapsed ? "px-2 py-3 lg:w-[96px]" : "p-6 lg:w-[312px] lg:p-4"
      } lg:duration-500 ${isChannel(["jek"]) ? "lg:top-4" : "lg:top-20"}`}
    >
      {profileType === "B2B" && (
        <div
          className={`bg-gray absolute -left-px top-12 flex size-6 -translate-x-1/2 cursor-pointer items-center justify-center rounded-full bg-opacity-[87%] duration-1000 max-lg:hidden ${
            isCollapsed ? "rotate-180" : "rotate-0"
          }`}
          onClick={() => setIsCollapsed((s) => !s)}
        >
          <div className="size-0 border-y-4 border-l-4 border-y-transparent border-l-white" />
        </div>
      )}

      <div
        className={`overflow-hidden ${
          isCollapsed ? "lg:w-[78px]" : "lg:w-[280px]"
        }`}
      >
        {list
          ?.filter((item) => item?.title || item?.id)
          .map((item) => (
            <ListItem
              isCollapsed={isCollapsed}
              key={item.id || (item.title as string)}
              {...item}
              className={`hover:bg-states-secondary-hover border-outline-thin !px-2 first:border-0 max-lg:border-t lg:rounded-xl ${
                item.selected
                  ? "bg-states-secondary-dragged text-secondary rounded-lg"
                  : ""
              } `}
              onClick={() => {
                if (item.role === "button") {
                  item.onClick?.();
                }
              }}
              title={
                item.hasNewLabel ? (
                  <div className="flex items-center gap-4">
                    {item.title}
                    <InfoChips
                      className="!rounded-3xl"
                      color="primary"
                      size="small"
                      text="جدید"
                    />
                  </div>
                ) : (
                  item.title
                )
              }
            />
          ))}
      </div>
    </div>
  );
};
